import { AppLocale, Locale } from './constants'

const TRADITIONAL_CHINESE_REGIONS = ['tw', 'hk', 'mo']

/**
 * Maps a BCP 47 tag (from `navigator.languages`, `expo-localization`, or storage)
 * to one of our locales. Traditional Chinese (zh-Hant, zh-TW/HK/MO) goes to
 * `zh-TW`, every other Chinese variant to `zh-CN`. Returns null when the language
 * is not one we ship.
 */
export const matchLocale = (tag: string | null | undefined): Locale | null => {
  if (!tag) return null
  const parts = tag.replace(/_/g, '-').toLowerCase().split('-')
  const language = parts[0]

  if (language === 'zh') {
    const rest = parts.slice(1)
    // An explicit script beats the region: zh-Hans-HK is simplified.
    if (rest.includes('hans')) return Locale.ZH_CN
    if (rest.includes('hant')) return Locale.ZH_TW
    return rest.some((part) => TRADITIONAL_CHINESE_REGIONS.includes(part))
      ? Locale.ZH_TW
      : Locale.ZH_CN
  }

  const match = (Object.values(Locale) as string[]).find(
    (locale) => locale.toLowerCase() === language
  )
  return (match as Locale) ?? null
}

/** First of the device's preferred languages that is also available in this build. */
export const pickDeviceLocale = (
  deviceTags: readonly string[],
  available: readonly AppLocale[]
): Locale | null => {
  for (const tag of deviceTags) {
    const locale = matchLocale(tag)
    if (locale && available.includes(locale)) return locale
  }
  return null
}
